var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-to-get"},[_c('block-header-standard',{attrs:{"title":_vm.t('HowToGet')}}),_c('map-with-directions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }